export function useFormatLicensePlate() {
  let invalidString = '';
  let newStr = '';
  let index = 0;
  const arrRegEx = [
    '^([A-Z]|[^0-9CIOY]{2})([0-9]{2})([0-9]{2})$', // XX9999 1951
    '^([0-9]{2})([0-9]{2})([A-Z]|[^0-9CIOY]{2})$', // 9999XX 1965
    '^([0-9]{2})([A-Z]|[^0-9CIOY]{2})([0-9]{2})$', // 99XX99 1973
    '^([BDFGHJKLMNPRSTVWXYZ]{2})([0-9]{2})([BDFGHJKLMNPRSTVWXYZ]{2})$', // XX99XX 1978
    '^([BDFGHJKLMNPRSTVWXZ]{2})([BDFGHJKLMNPRSTVWXZ]{2})([0-9]{2})$', // XXXX99 1991
    '^([0-9]{2})([BDFGHJKLMNPRSTVWXZ]{2})([BDFGHJKLMNPRSTVWXZ]{2})$', // 99XXXX 1999
    '^([0-9]{2})([BDFGHJKLMNPRSTVWXZ]{3})([0-9]{1})$', // 99XXX9 2005
    '^([0-9]{1})([BDFGHJKLMNPRSTVWXZ]{3})([0-9]{2})$', // 9XXX99 2009
    '^([BDFGHJKLMNPRSTVWXZ]{2})([0-9]{3})([BDFGHJKLMNPRSTVWXZ]{1})$', // XX999X 2006
    '^([BDFGHJKLMNPRSTVWXZ]{1})([0-9]{3})([BDFGHJKLMNPRSTVWXZ]{2})$', // X999XX 2008
    '^([BDFGHJKLMNPRSTVWXZ]{3})([0-9]{2})([BDFGHJKLMNPRSTVWXZ]{1})$', // XXX99X 11 2015
    '^([BDFGHJKMNPRSVWXZ]{1})([0-9]{2})([BDFGHJKLMNPRSTVWXZ]{3})$', // X99XXX 12 2021
    '^([0-9]{1})([BDFGHJKLMNPRSTVWXZ]{2})([0-9]{3})$', //9XX999 13 2016
    '^([0-9]{3})([BDFGHJKLMNPRSTVWXZ]{2})([0-9]{1})$', //999XX9 14 2019
  ];

  const forbiddenCharacters = /^((?!GVD|KKK|KVT|LPF|NSB|PKK|PSV|TBS|SS|SD|PVV|SGP|VVD).){8}$/;

  const matchLicense = (str) => {
    return arrRegEx.some((regEx, i) => {
      const re = new RegExp(regEx);
      const result = re.test(str);

      if (result) {
        index = i;
        return true;
      }
    });
  };

  const checkForbiddenCharacters = (str) => {
    return forbiddenCharacters.test(str);
  };

  const showLicense = (str) => {
    const match = matchLicense(str);

    if (match) {
      const re = new RegExp(arrRegEx[index]);

      newStr = str.replace(re, '$1-$2-$3');
      const notForbidden = checkForbiddenCharacters(newStr);
      if (notForbidden) {
        return newStr;
      }
    }

    return invalidString;
  };

  const formatLicensePlate = (license) => {
    if (typeof license !== 'string') return;

    if (license.length == 0) return '';

    const str = license.toUpperCase().trim().split('-').join('');
    return showLicense(str);
  };

  return { formatLicensePlate };
}
